"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsSerializer = void 0;
var option_model_1 = require("../../../models/settings/option.model");
var OptionsSerializer = /** @class */ (function () {
    function OptionsSerializer(playerOptionSerializer, scoreOptionSerializer, reportingOptionsSerializer, assessmentTypeOptionsSerializer, standardsOptionsSerializer) {
        this.playerOptionSerializer = playerOptionSerializer;
        this.scoreOptionSerializer = scoreOptionSerializer;
        this.reportingOptionsSerializer = reportingOptionsSerializer;
        this.assessmentTypeOptionsSerializer = assessmentTypeOptionsSerializer;
        this.standardsOptionsSerializer = standardsOptionsSerializer;
    }
    OptionsSerializer.prototype.serialize = function (_a) {
        var player = _a.player, scores = _a.scores, reporting = _a.reporting, customization = _a.customization, assign = _a.assign, standards = _a.standards;
        var serializedPlayer = player ? this.playerOptionSerializer.serialize(player) : undefined;
        var serializedScores = scores ? this.scoreOptionSerializer.serialize(scores) : undefined;
        var serializedReporting = reporting
            ? this.reportingOptionsSerializer.serialize(reporting)
            : undefined;
        var serializedCustomization = customization
            ? this.assessmentTypeOptionsSerializer.serialize(customization)
            : undefined;
        var serializedAssign = assign
            ? this.assessmentTypeOptionsSerializer.serialize(assign)
            : undefined;
        var serializedStandards = standards
            ? this.standardsOptionsSerializer.serialize(standards)
            : undefined;
        return new option_model_1.Option({
            player: serializedPlayer,
            scores: serializedScores,
            reporting: serializedReporting,
            customization: serializedCustomization,
            assign: serializedAssign,
            standards: serializedStandards,
        });
    };
    return OptionsSerializer;
}());
exports.OptionsSerializer = OptionsSerializer;
